import { type SSRConfig, type SSRFeatureFlags } from '../../../types';

export const ssrFeatureFlags = (
	ssr: SSRConfig | null,
): {
	'ssr:featureFlags': SSRFeatureFlags;
} | null => {
	if (!ssr?.getFeatureFlags) {
		return null;
	}

	try {
		const featureFlags = ssr.getFeatureFlags();
		if (featureFlags) {
			return { 'ssr:featureFlags': featureFlags };
		}
	} catch (e) {}
	return null;
};
